import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GaTrackingEventAction, GaTrackingEventCategory } from '~shared/modules/ga-tracking/constants';

export class OrderHistorySideMenuApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.OrderHistorySideMenuInteraction;

  constructor(private label?: string) {
  }

  getPayload(): any {
    return {
      action: GaTrackingEventAction.OrderHistorySideMenu,
      event: GaTrackingEventCategory.OrderHistorySideMenu,
      label: this.label,
      category: GaTrackingEventCategory.OrderHistorySideMenu,
    };
  }
}
